/** @format */

import React, { useState } from 'react'

import moment from 'moment'

import { notification, Form, Button, Modal } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'

import AproveForm from './components/AproveForm'
import RejectForm from './components/RejectForm'

export default function ActionsButtons(props) {
	const [form] = Form.useForm()
	const [modal, setModal] = useState(false)
	const [loading, setLoading] = useState(false)
	const [reason, setReason] = useState({
		label: '',
		text: '',
	})

	const handleSendData = async (item) => {
		if (moment().isBefore(item.schedule)) {
			await props.handleAproveOrReject({
				...item,
				scheduleSelected: moment(item.schedule._d).format(),
				status: props.newStatus,
			})
		} else {
			notification['error']({
				message: 'Error de fecha',
				description: 'La fecha seleccionada debe ser después de la fecha actual.',
			})
		}
	}

	return (
		<>
			<Button
				loading={loading}
				onClick={async () => {
					if (props.status === 100 && props.action === 'aprove') {
						setLoading(true)
						await props.handleAproveOrReject({
							status: props.quotationType === 'contract' ? 300 : 200,
						})
						setLoading(false)
					} else {
						setModal(true)
					}
				}}
				type='primary'
				icon={props.action === 'aprove' ? <CheckOutlined /> : <CloseOutlined />}
				danger={props.danger ? true : false}
				className='ph-order-actions-buttons'>
				<span>{props.labelName}</span>
			</Button>
			<Modal
				title={props.title}
				visible={modal}
				onCancel={() => setModal(false)}
				footer={[
					<Button key='back' onClick={() => setModal(false)}>
						Cerrar
					</Button>,
					<Button
						key='submit'
						type='primary'
						disabled={reason.label === 'Otro' && reason.text === ''}
						onClick={async () => {
							if (props.newStatus === 300) {
								form.submit()
							} else {
								await props.handleAproveOrReject({
									reason: reason.label === 'Otro' ? reason.text : reason.label,
									status: 500,
								})
							}
						}}
						danger={props.action === 'aprove' ? false : true}>
						{props.action === 'aprove' ? 'Aprobar' : 'Rechazar'}
					</Button>,
				]}
				forceRender>
				{props.action === 'aprove' ? (
					<AproveForm
						form={form}
						quotationType={props.quotationType}
						handleSendData={handleSendData}
					/>
				) : (
					<RejectForm
						reason={reason}
						handleSelectChange={(item) =>
							setReason((previouStatus) => ({
								...previouStatus,
								label: item.label,
							}))
						}
						handleTextAreaChange={(item) =>
							setReason((previouStatus) => ({
								...previouStatus,
								text: item.target.value,
							}))
						}
					/>
				)}
			</Modal>
		</>
	)
}
